import { AddCircleOutlineOutlined, Delete, Edit, Info } from '@mui/icons-material'
import { Button, Card, CardActions, CardContent, CardHeader, Container, CssBaseline, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, Outlet, useOutletContext } from 'react-router-dom'
import Swal from 'sweetalert2'
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs'
import { AuthStore } from '../../../../store/UserStore'
import { base_url } from '../../../../utils/GlobalVariables'
import { CustomDescrypt } from '../../../../utils/MyEncryption'
import no_data from '../../../../assets/images/no_data.webp'

const Kontrak = () => {
    const [breadcrumbItem, setBreadcrumbItem] = useState({})

    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="Kontrak" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet context={{ setBreadcrumbItem }} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

const Data = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const logOut = AuthStore((state) => state.logOut)
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [deleting, setDeleting] = useState([]);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/kontrak': 'Kontrak' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleting]);

    const requestData = () => {
        // setTableLoading(true)
        axios.get(
            base_url + '/bnd/kontrak',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setTableData(data)
                console.log(tableData.length);
                // setTableLoading(false)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const deleteData = (params) => {
        setDeleting(true);
        const frmData = {
            _method: 'DELETE',
            no_kontrak: params
        }

        Swal.fire({
            title: 'Hapus Data?',
            text: "Operasi tidak dapat Dikembalikan!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal',
            preConfirm: () => {
                return axios.post(
                    base_url + '/bnd/kontrak/delete',
                    frmData,
                    {
                        headers: {
                            'Authorization': `Bearer ${decryptedUser.token}`,
                            'content-type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        requestData();
                        return response.data
                    })
                    .catch((error) => {
                        if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                            logOut();
                        }
                        else {
                            console.log(error.response);
                            Swal.showValidationMessage(
                                `Request failed: ${error.response.statusText}`
                            )
                        }
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            console.log(result);
            if (result.isConfirmed) {
                Swal.fire(
                    'Selesai!',
                    result.value.msg,
                    'success'
                )
            }
        })

    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    return (
        <Card variant='outlined'>
            <CardHeader
                title="Data Kontrak"
                action={
                    <Button
                        variant="contained"
                        endIcon={<AddCircleOutlineOutlined color='white' />}
                        to="/bnd/kontrak/add"
                        component={Link}
                    >
                        Tambah
                    </Button>
                }
            />
            <CardContent>
                <Grid container spacing={2}>
                    {
                        tableData.length > 0 ?
                            tableData.map((item) => (
                                <Grid item xs={8} md={6} xl={6} key={item.no_kontrak}>
                                    <Card>
                                        <CardContent>
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                {item.tgl_kontrak + "    "}
                                            </Typography>
                                            <Typography variant="h5" component="div">
                                                No. {item.no_kontrak}
                                            </Typography>
                                            {/* <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                No. SPK {item.nomor_spk}
                                            </Typography> */}
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                {item.pekerjaan}
                                            </Typography>
                                            <Typography variant="h6">
                                                {item.nama_perusahaan}
                                            </Typography>
                                            <Typography variant="h5">
                                                Rp. {rP(item.jumlah_kontrak)}
                                            </Typography>
                                            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                                Terealisasi Rp. {rP(item.terealisasi)} ({((item.terealisasi / item.jumlah_kontrak) * 100).toFixed(2)}%)
                                            </Typography>
                                        </CardContent>
                                        <CardActions>
                                            {/* <Tooltip title="Hapus">
                                                <IconButton aria-label="delete" color='error' onClick={() => deleteData(item.no_kontrak)}>
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    aria-label="edit"
                                                    color="info"
                                                    component={Link}
                                                    to="/bnd/kontrak/edit"
                                                    state={item}>
                                                    <Edit />
                                                </IconButton>
                                            </Tooltip> */}
                                            <Tooltip title="Info">
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<Info />}
                                                    color='success'
                                                    component={Link}
                                                    to="/bnd/kontrak/detail"
                                                    state={item}
                                                >
                                                    Lihat Data
                                                </Button>
                                                {/* <IconButton
                                                    aria-label="confirm"
                                                    color='success'
                                                    component={Link}
                                                    to="/bnd/kontrak/detail"
                                                    state={item}
                                                >
                                                    <Info />
                                                </IconButton> */}
                                            </Tooltip>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))
                            :
                            <Grid container mt={5} spacing={2} justifyContent="center">
                                <Grid item lg={6} md={6} sm={12} sx={{ textAlign: "center" }}>
                                    <img
                                        src={no_data}
                                        srcSet={no_data}
                                        alt={"No Data"}
                                        loading="lazy"
                                        sx={{
                                            objectFit: 'contain',
                                            padding: "1em 1em 0 1em"
                                        }}
                                    />
                                </Grid>
                            </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    )

}

export { Data as DataKontrak }
export default Kontrak